import { useState, useEffect } from "react";
import {
  Frame,
  Loading,
  Header,
  Print,
  VerContrato,
  ValidaUid,
} from "../components";
import { useNavigate } from "react-router-dom";
import { db } from "../config/firebase";
import { doc, getDoc } from "firebase/firestore";

const Contrato = () => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "furg2026", uid));

      const data = qry.data();

      const contrato = data?.contrato;
      const status = data?.status;

      if (contrato === "2026" && status === "a") {
        setLoading(false);
        setDados(data);
      } else navigate("../home");
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      {!loading && (
        <Frame
          body={
            <div className="px-2">
              <VerContrato dados={dados} />
              <Print />
            </div>
          }
        />
      )}
    </>
  );
};

export default Contrato;
